// removed by extract-text-webpack-plugin
module.exports = {"img":"G7hVPVjRIbWnvTy4yNZUO","myExperienceShop":"_3i92Sv5eB8L9yqXC7LM2yI","experienceShopNearby":"_3_P7q-R04_IYatj9IurnwJ","backToHome":"_9Csse9HFt1-n65ed096gQ","more":"JWTqlzX40lLRqgfjkZQZ4"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/VrProductPage/VrProductPage.scss
 ** module id = 1099
 ** module chunks = 0
 **/